import React from "react";

export default function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="189.333"
      height="32"
      version="1.1"
      viewBox="0 0 189.333 32"
      xmlSpace="preserve"
    >
      <defs>
        <clipPath id="clipPath20" clipPathUnits="userSpaceOnUse">
          <path d="M0 0h595v842H0z"></path>
        </clipPath>
        <clipPath id="clipPath30" clipPathUnits="userSpaceOnUse">
          <path d="M0 0h1860.66v680.316H0z"></path>
        </clipPath>
      </defs>
      <g transform="matrix(1.33333 0 0 -1.33333 0 32)">
        <g transform="translate(-22 -22)">
          <g>
            <g clipPath="url(#clipPath20)">
              <g transform="scale(.1)">
                <g>
                  <g
                    fill="#231f20"
                    fillOpacity="1"
                    fillRule="nonzero"
                    stroke="none"
                    clipPath="url(#clipPath30)"
                  >
                    <path d="M1091.8 287.27c-8.1-40.165-39.13-42.211-45.28-42.211-17.52 0-27.97 10.121-27.97 27.046 0 3.86.57 9.122 1.55 14.387l19.19 95.617.09.368h-22.68l-19.552-98.047-.257-1.403c-.84-4.429-1.625-8.629-1.625-14.078 0-26.344 17.294-44.019 43.084-44.019 18.86 0 34.01 6.187 45.07 18.41l-2.94-16.152-.07-.383h22.35l30.88 155.304.07.368h-23l-18.91-95.207"></path>
                    <path d="M1246.35 384.363c-17.52 0-33.04-7.16-42.81-19.734l3.51 17.48.06.368h-22.35l-30.89-155.289-.07-.383h22.69l18.91 95.246c4.83 24.449 23.6 42.176 44.65 42.176 9.04 0 16.16-3.563 21.76-10.872l.21-.285 18.41 16.489-.19.238c-8.5 9.82-19.6 14.566-33.89 14.566"></path>
                    <path d="M871.492 362.73l-.066-.386h77.359L845.793 245.898l-.055-.058-3.883-19.035h109.782l3.906 20.144h-82.066l103.308 116.449.051.067 3.871 19.012H875.336l-3.844-19.747"></path>
                    <path d="M1283.32 227.188l-.08-.383h22.67l30.93 155.672h-22.29l-31.23-155.289"></path>
                    <path d="M1590.72 384.355c-18.65 0-33.21-5.714-44.4-17.496l17.59 86.688h-22.68l-45.56-226.762h22.68l18.91 95.258c8.1 40.148 39.41 42.18 45.59 42.18 17.34 0 27.69-10.114 27.69-27.039 0-3.84-.59-9.079-1.58-14.403l-19.24-95.996h22.65l19.89 98.086c.95 5.219 1.59 9.621 1.59 15.469 0 26.332-17.36 44.015-43.13 44.015"></path>
                    <path d="M1440.41 384.363c-41.13 0-70-28.972-79.23-79.492-1.66-8.461-2.23-17.922-2.23-23.969 0-34.519 20.95-55.972 54.71-55.972 19.63 0 37.55 7.527 51.81 21.773l.2.215-13.07 15.953-.24.281-.24-.265c-12.03-12.657-22.81-17.828-37.21-17.828-16.09 0-33.3 9.578-33.3 36.48 0 8.418 1 15.375 2.49 23.215 2.43 13.199 7.9 31.641 20.05 44.469 9.66 9.957 21.11 15.004 34.06 15.004 13.52 0 21.98-4.809 30.22-17.149l.19-.305 16.64 14.063.24.195-.18.254c-11.36 15.969-25.22 23.078-44.91 23.078"></path>
                    <path d="M1322.96 425.199h22.72l5.65 28.348h-22.64l-5.73-28.348"></path>
                    <path d="M1102.49 425.199h22.73l5.62 28.348h-22.61l-5.74-28.348"></path>
                    <path d="M1042.03 425.199h22.72l5.64 28.348h-22.62l-5.74-28.348"></path>
                    <path d="M739.102 365.68h-51.016L706 453.547H272.355l-45.542-226.762h172.898l11.324 56.68H308.949l6.192 31.183h102.05l10.274 51.032H325.391l6.179 31.183h161.805l-34.16-170.078h70.867l34.156 170.078h59.496l-34.156-170.078h70.883l17.488 87.863h51.004l-17.488-87.863h70.863l45.563 226.762H757.02l-17.918-87.867"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

